import { ROUTES } from '~shared/config/routes';

export function pushApplicationIdToUrl(applicationId: string): void {
  const newUrl = ROUTES.partner.applicationEdit.link(applicationId);
  window.history.replaceState(null, '', newUrl);
}
